import React, { useEffect, useState } from "react";
import { MessagesSquare } from "lucide-react";
import { parApi } from "@/lib/partnerApi";
import { useFloatingWindows } from "@/lib/floatingWindows";
import { MEMOS_CHANGED } from "@/components/nds/windows/partner/memos/PartnerMemosContent";

/** Header count of unread partner memos (staff: from partners · partners: from staff); opens Partner Memos. */
export function MemosBadge() {
  const [c, setC] = useState(null);
  const { openWindow } = useFloatingWindows();
  useEffect(() => {
    const load = () => parApi.get("/memos/unread-count").then(setC).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener(MEMOS_CHANGED, load);
    return () => { clearInterval(t); window.removeEventListener(MEMOS_CHANGED, load); };
  }, []);
  if (!c) return null;
  const tone = c.urgent ? "border-red-400/60 text-red-200 hover:bg-red-500/10" : c.unread ? "border-nex-gold/60 text-nex-gold hover:bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver";
  return (
    <button type="button" onClick={() => openWindow("par_memos", { title: "Partner Memos" })} data-testid="memos-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-mono text-[10px] tracking-[0.16em] uppercase transition-colors ${tone}`}>
      <MessagesSquare className="h-3 w-3" /> <span data-testid="memos-badge-count">{c.unread}</span> memo{c.unread === 1 ? "" : "s"}{c.urgent ? ` · ${c.urgent} urgent` : ""}
    </button>
  );
}
